import React, { useState,useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "./authService";
import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import api from "../api";
import { CartContext } from "../cart/CartContext";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  useEffect(() => {
      document.title = "Login | Workgear365";
    }, []);
    const { fetchCart } = useContext(CartContext);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: "", password: "", remember: false });
    const [errors, setErrors] = useState([]);
    const { setUser } = useContext(AuthContext); // 👈 use context
    const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    try {  
      const response = await login(formData);

      if (response.data && response.data.user) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem("token", response.data.token);
        setUser(response.data.user); // 👈 update user in context
         // ✅ IMPORTANT: call merge cart
        await api.post('/api/cart/merge');

        // ✅ Then fetch updated cart
       if (typeof fetchCart === "function") {
          await fetchCart();
        } else {
          console.log("fetchCart is not function:", fetchCart);
        }
       
      }

      navigate("/"); // redirect after login
    } catch (err) {
      if (err.response) {
        console.log(err.response.data); // 👈 ADD THIS
        setErrors(
          err.response.data.errors
            ? Object.values(err.response.data.errors).flat()
            : [err.response.data.message]
        );
      } else {
        setErrors(["Something went wrong"]);
      }
    }
  };

  return (
    <div className="auth-sell-center">
    <div className="wg-auth-shell">
      <div className="wg-auth-card">
        <div className="wg-auth-head">
          <div className="wg-auth-title">Welcome back</div>
          <div className="wg-auth-sub">
            Sign in to manage your orders, quotes, and saved designs.
          </div>
        </div>
        {errors.length > 0 && (
                <div>
                  {errors.map((err, idx) => (
                    <p key={idx} style={{ color: "red" }}>{err}</p>
                  ))}
                </div>
              )}
        <form onSubmit={handleSubmit}>
          {/* Email */}
          <div className="wg-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              className="wg-input"
              placeholder="name@company.com"
              value={formData.email}
                    onChange={handleChange}
                    required
            />
            {emailError && <div className="wg-error">{emailError}</div>}
          </div>

          {/* Password */}
          <div className="wg-field">
            <label>Password</label>

            <div className="wg-pass-wrap">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="wg-input"
                placeholder="********"
                value={formData.password}
                    onChange={handleChange}
                    required
              />

              <button
                type="button"
                className="wg-pass-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            {passwordError && (
              <div className="wg-error">{passwordError}</div>
            )}
          </div>

          {/* Remember */}
          <div className="wg-helper-row">
            <label className="wg-checkbox">
              <input
                type="checkbox"
                name="remember"
                checked={formData.remember}
                    onChange={handleChange}
              />
              Remember me
            </label>
          </div>

          {/* Forgot */}
          <div className="wg-forgot">
            <a className="wg-link" href="/forgot-password">Forgot password?</a>
            
          </div>

          {/* Button */}
          <div className="wg-actions-login">
            <button type="submit" className="wg-btn-primary">
              Sign in
            </button>
          </div>

          <div
            className="wg-footer1"
            style={{ textAlign: "left", marginTop: "12px" }}
          >
            By continuing, you agree to WorkGear365's{" "}
            <a className="wg-link" href="/terms">Terms & Conditions</a> and{" "}
            <a className="wg-link" href="/privacy">Privacy Notice</a>.
          </div>
        </form>

        <div className="wg-divider"></div>

        <div className="wg-footer1">
          Don't have an account?{" "}
          <a className="wg-link" href="registration">Register for one</a>!
        </div>
      </div>
    </div>
    </div>
  );
}
export default LoginPage;